const Constants = {
  routes: {
    root: '/',
    menu: '/menu',
    gip: '/details',
    bpsMarket: '/bps/market',
    rankings: '/rankings',
    rankingsMap: '/rankings/map',
    rankingsCountry: '/rankings/map/:countryCode',
    rankingsCountryGraphics: '/rankings/map/:countryCode/graphics',
    rankingsTiers: '/rankings/:yearCode/tiers',
    rankingsTierGraphics: '/rankings/:yearCode/tiers/:tierCode',
    economicResearch: '/economic-research',
    gipDownload: '/economic-research-gip-download',
    error: '/error',
    bps: '/bps',
    bpsRegions: '/bps/economic-regions',
    bpsProportion: '/bps/markets-proportion',
  },
  values: {
    headerHeight: '5vh',
    sidebarHeight: '95vh',
    contentHeight: '95vh'
  }
};

export default Constants;
